import Offer from "./offer";

export enum OfferStatus {
    Unknown,
    Working = 1,
    Pending = 2,
    Filled = 3,
    Cancelled = 5,
    Expired = 6
}

export const AllOfferStatuses = [
    OfferStatus.Working,
    OfferStatus.Pending,
    OfferStatus.Filled,
    OfferStatus.Cancelled,
    OfferStatus.Expired
];

export function isAllowed(offer: Offer, ...allowedStatuses: OfferStatus[]): boolean {
    return allowedStatuses.some(s => offer.status === s);
}
